import Typography from "@mui/material/Typography";
import React from "react";


export const NoResultsMessage = () => (
    <Typography variant="h6" align="center" color="textSecondary" sx={{ mt: 2 }}>
        Немає результатів за вашим пошуком
    </Typography>
);